import FormHelperText from '@mui/material/FormHelperText'
import { uploadImage } from '@repo/shared-images-client-utils'
import { Control, Controller, useFormContext } from 'react-hook-form'
import { UploadProps } from '../../../inputs/Upload'
import { UploadAvatar } from '../../../inputs/Upload/UploadAvatar'

// --------------------------------------------------------------------------------------------- //

interface Props extends Omit<UploadProps, 'file'> {
  name: string
}

export function RHFUploadAvatar({ name, ...other }: Props) {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const checkError = !!error && !field?.value

        const onDrop = async (acceptedFiles: File[]) => {
          const file = acceptedFiles[0]
          const data = await uploadImage({ file })

          Object.assign(data, { preview: URL.createObjectURL(file) })

          if (file) {
            field.onChange(data?.url)
          }
        }

        return (
          <div>
            <UploadAvatar accept={{ 'image/*': [] }} error={checkError} onDrop={onDrop} value={field?.value} {...other} />
            {checkError && (
              <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                {error?.message}
              </FormHelperText>
            )}
          </div>
        )
      }}
    />
  )
}

// ----------------------------------------------------------------------------------------------------------------------------- //

export function RHFUploadAvatarNoContext({ name, control, ...other }: Props & { control: Control }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const checkError = !!error && !field?.value

        const onDrop = async (acceptedFiles: File[]) => {
          const file = acceptedFiles[0]
          const data = await uploadImage({ file })

          Object.assign(data, { preview: URL.createObjectURL(file) })

          if (file) {
            field.onChange(data?.url)
          }
        }

        return (
          <div>
            <UploadAvatar accept={{ 'image/*': [] }} error={checkError} onDrop={onDrop} {...other} value={field?.value} />
            {checkError && (
              <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                {error?.message}
              </FormHelperText>
            )}
          </div>
        )
      }}
    />
  )
}
